var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "img-list" },
    [
      _vm.showFileList
        ? [
            _vm.type === "image"
              ? _vm._l(_vm.list, function (item, i) {
                  return _c("div", { key: i }, [
                    item
                      ? _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: item,
                              expression: "item",
                            },
                          ],
                          staticClass: "img-thumb",
                          style:
                            "width:" +
                            _vm.width +
                            "px;height:" +
                            _vm.height +
                            "px;object-fit:" +
                            _vm.objectFit,
                          attrs: { "data-index": i },
                          on: {
                            click: function ($event) {
                              return _vm.open(i)
                            },
                          },
                        })
                      : _vm._e(),
                  ])
                })
              : _vm._e(),
            _vm.type === "video"
              ? _vm._l(_vm.list, function (item, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "video-item",
                      style:
                        "width:" + _vm.width + "px;height:" + _vm.height + "px",
                      on: {
                        click: function ($event) {
                          return _vm.open(i)
                        },
                      },
                    },
                    [
                      _c("video", {
                        staticClass: "video-item_thumb",
                        style:
                          "width:" +
                          _vm.width +
                          "px;height:" +
                          _vm.height +
                          "px;object-fit:" +
                          _vm.objectFit,
                        attrs: { "data-index": i, controls: false, src: item },
                      }),
                      _c("i", {
                        staticClass: "el-icon-video-play video-item_icon",
                      }),
                    ]
                  )
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.isShow
        ? _c("div", { staticClass: "img-popup" }, [
            _c("div", { staticClass: "img-popup-mask" }),
            _c("div", { staticClass: "img-popup-inner" }, [
              _vm.list.length > 1
                ? _c("div", { staticClass: "img-popup-count" }, [
                    _vm._v(
                      _vm._s(_vm.currentIndex + 1) +
                        " / " +
                        _vm._s(_vm.list.length)
                    ),
                  ])
                : _vm._e(),
              _c("i", {
                staticClass: "icon-close el-icon-close",
                on: { click: _vm.close },
              }),
              _vm.currentIndex > 0
                ? _c(
                    "div",
                    {
                      staticClass: "img-popup-icon prev",
                      on: {
                        click: function ($event) {
                          return _vm.change("prev")
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-arrow-left" })]
                  )
                : _vm._e(),
              _vm.type === "image"
                ? _c("img", {
                    staticClass: "img-popup-thumb",
                    attrs: {
                      src: _vm.list[_vm.currentIndex],
                      "data-index": _vm.currentIndex,
                      alt: "",
                    },
                    on: { click: _vm.close },
                  })
                : _c("video", {
                    staticClass: "video",
                    attrs: {
                      "data-index": _vm.currentIndex,
                      controls: "",
                      autoplay: "",
                      src: _vm.list[_vm.currentIndex],
                    },
                  }),
              _vm.currentIndex < _vm.list.length - 1
                ? _c(
                    "div",
                    {
                      staticClass: "img-popup-icon next",
                      on: {
                        click: function ($event) {
                          return _vm.change("next")
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-arrow-right" })]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }